import { render } from "./headertwomenu.vue?vue&type=template&id=025da463"
import script from "./headertwomenu.vue?vue&type=script&lang=js"
export * from "./headertwomenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__